var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSortArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.67725 0.981934C4.21533 0.981934 3.89844 1.3042 3.89844 1.7876V7.74951L3.95215 8.91504L2.87256 7.66895L1.66406 6.46582C1.52441 6.3208 1.3418 6.22412 1.10547 6.22412C0.686523 6.22412 0.369629 6.53564 0.369629 6.97607C0.369629 7.18018 0.450195 7.36816 0.611328 7.53467L4.10254 11.0312C4.24756 11.1816 4.46777 11.2676 4.67725 11.2676C4.89209 11.2676 5.10693 11.1816 5.25195 11.0312L8.74854 7.53467C8.90967 7.36816 8.99023 7.18018 8.99023 6.97607C8.99023 6.53564 8.67334 6.22412 8.25439 6.22412C8.02344 6.22412 7.84082 6.3208 7.6958 6.46582L6.4873 7.66895L5.40771 8.91504L5.45605 7.74951V1.7876C5.45605 1.3042 5.14453 0.981934 4.67725 0.981934Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortArrow);
export default __webpack_public_path__ + "static/media/sortArrow.9bc95b22.svg";
export { ForwardRef as ReactComponent };